// Standard genetic code (NCBI translation table 1). Codon (DNA, T not U) →
// amino-acid single-letter code; "*" is a stop codon.
export const CODON_TABLE: Record<string, string> = {
  TTT: "F",
  TTC: "F",
  TTA: "L",
  TTG: "L",
  CTT: "L",
  CTC: "L",
  CTA: "L",
  CTG: "L",
  ATT: "I",
  ATC: "I",
  ATA: "I",
  ATG: "M",
  GTT: "V",
  GTC: "V",
  GTA: "V",
  GTG: "V",
  TCT: "S",
  TCC: "S",
  TCA: "S",
  TCG: "S",
  CCT: "P",
  CCC: "P",
  CCA: "P",
  CCG: "P",
  ACT: "T",
  ACC: "T",
  ACA: "T",
  ACG: "T",
  GCT: "A",
  GCC: "A",
  GCA: "A",
  GCG: "A",
  TAT: "Y",
  TAC: "Y",
  TAA: "*",
  TAG: "*",
  CAT: "H",
  CAC: "H",
  CAA: "Q",
  CAG: "Q",
  AAT: "N",
  AAC: "N",
  AAA: "K",
  AAG: "K",
  GAT: "D",
  GAC: "D",
  GAA: "E",
  GAG: "E",
  TGT: "C",
  TGC: "C",
  TGA: "*",
  TGG: "W",
  CGT: "R",
  CGC: "R",
  CGA: "R",
  CGG: "R",
  AGT: "S",
  AGC: "S",
  AGA: "R",
  AGG: "R",
  GGT: "G",
  GGC: "G",
  GGA: "G",
  GGG: "G",
};

// Amino-acid single-letter → three-letter code + full name.
export const AMINO_ACIDS: Record<string, { three: string; name: string }> = {
  A: { three: "Ala", name: "Alanine" },
  R: { three: "Arg", name: "Arginine" },
  N: { three: "Asn", name: "Asparagine" },
  D: { three: "Asp", name: "Aspartate" },
  C: { three: "Cys", name: "Cysteine" },
  Q: { three: "Gln", name: "Glutamine" },
  E: { three: "Glu", name: "Glutamate" },
  G: { three: "Gly", name: "Glycine" },
  H: { three: "His", name: "Histidine" },
  I: { three: "Ile", name: "Isoleucine" },
  L: { three: "Leu", name: "Leucine" },
  K: { three: "Lys", name: "Lysine" },
  M: { three: "Met", name: "Methionine" },
  F: { three: "Phe", name: "Phenylalanine" },
  P: { three: "Pro", name: "Proline" },
  S: { three: "Ser", name: "Serine" },
  T: { three: "Thr", name: "Threonine" },
  W: { three: "Trp", name: "Tryptophan" },
  Y: { three: "Tyr", name: "Tyrosine" },
  V: { three: "Val", name: "Valine" },
  "*": { three: "Ter", name: "Stop" },
};

/** All synonymous codons grouped by the amino acid they encode. */
export function synonymousCodons(): Record<string, string[]> {
  const groups: Record<string, string[]> = {};
  for (const [codon, aa] of Object.entries(CODON_TABLE)) {
    (groups[aa] ??= []).push(codon);
  }
  return groups;
}
